module.exports = __webpack_public_path__ + "img/image_not_available.474a6836.png";